import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useProperty } from "../PropertyContext";

import ReservationSidebar from "./Commun/ReservationSidebar";
import ReservationHeader from "./Commun/ReservationHeader";
import { ReservationBookingCancle, ReservationBookinglist, Reservationbookingpdf } from "../Services/Service";
// import ReactDOMServer from 'react-dom/server';
import html2pdf from 'html2pdf.js';



const ReservationBookingList = () => {
    const [loading, setLoading] = useState(false);
    const [bookingList, setBookingList] = useState([]);
    const location = useLocation();
    const [showSuccess, setShowSuccess] = useState(false);
    const [bankFormData, setBankFormData] = useState(null);
    const { selectedProperty } = useProperty();

    useEffect(() => {
        const FetchBookingList = async () => {
            setLoading(true);
            // if (!selectedProperty?.PropertyID) return;
            if (!selectedProperty?.PropertyID) {
                setBookingList([]); // Clear table if no property
                return;
            }
            try {
                const result = await ReservationBookinglist(selectedProperty.PropertyID);
                console.log("Booking API result:", result);
                setBookingList(result);
            } catch (error) {
                console.log("error get Booking list", error);
            } finally {
                setLoading(false);
            }
        };
        FetchBookingList();
    }, [selectedProperty]);



    useEffect(() => {
        if (location.state?.showSuccess) {
            setShowSuccess(true);


            setTimeout(() => setShowSuccess(false), 3000);
        }
    }, [location.state]);


    // const handleGeneratePDF = async (booking) => {
    //     setLoading(true);
    //     try {
    //         const voucherData = await Reservationbookingpdf(booking.BONRESID);

    //         if (!voucherData) {
    //             alert("Unable to fetch voucher details");
    //             return;
    //         }

    //         const voucherHTML = ReactDOMServer.renderToString(
    //             <BookingVoucherPage data={voucherData} />
    //         );

    //         const opt = {
    //             margin: 0,
    //             filename: `BookingVoucher_${booking.BONRESID}.pdf`,
    //             image: { type: "jpeg", quality: 0.98 },
    //             html2canvas: { scale: 2 },
    //             jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
    //         };

    //         html2pdf().set(opt).from(voucherHTML).save();
    //     } catch (error) {
    //         console.error("Error generating voucher PDF:", error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const safe = (val) => (val === null || val === undefined ? "" : String(val));

    const random = Math.floor(Math.random() * 1000) + 1;

    const handleGeneratePDF = async (booking) => {
        setLoading(true);
        try {
            // 1. Get voucher data from API
            const voucherData = await Reservationbookingpdf(booking.BONRESID);
            if (!voucherData) {
                alert("Unable to fetch voucher details");
                return;
            }

            const guest = voucherData.Table?.[0] || {};
            const room = voucherData.Table1?.[0] || {};
            const hotel = voucherData.Table3?.[0] || {};
            const BookingID = voucherData.Table4?.[0] || {};
            const bookingCommentObj = guest.BookingComment ? JSON.parse(guest.BookingComment)[0] : {};
            const bookingComment = bookingCommentObj?.BookingComment || "";

            const adultsCount = Number(room.adults ?? room.Adults ?? 0) || 0;
            const childrenCount = Number(room.Child ?? room.Children ?? room.child ?? 0) || 0;
            const guestsToShow = adultsCount + childrenCount;

            let paymentComment = "";
            try {
                const paymentCommentArr = guest.PaymentComment ? JSON.parse(guest.PaymentComment) : null;
                paymentComment = Array.isArray(paymentCommentArr) && paymentCommentArr.length ? (paymentCommentArr[0].PaymentComment || "") : "";
            } catch (e) {
                paymentComment = "";
            }

            // Get TotalRoom - prefer guest.TotalRoom, fallback to BookingID.TotalRoom or room.TotalRoom
            const totalRoom = (typeof guest.TotalRoom === "number" && guest.TotalRoom >= 0)
                ? guest.TotalRoom
                : (typeof BookingID.TotalRoom === "number" && BookingID.TotalRoom >= 0)
                    ? BookingID.TotalRoom
                    : (typeof room.TotalRoom === "number" && room.TotalRoom >= 0)
                        ? room.TotalRoom
                        : 0;

            // const propertyId = Number(localStorage.getItem("PropertyID"));
            const propertyId = Number(selectedProperty.PropertyID);

            let filePath = "";
            if (propertyId === 27) filePath = "/Voucher Templates/Uday_Palace_27.html?v=" + random;
            else if (propertyId === 25) filePath = "/Voucher Templates/Haword_Johnson_25.html?v=" + random;
            else if (propertyId === 26) filePath = "/Voucher Templates/Neemaya_26.html?v=" + random;
            else if (propertyId === 29) filePath = "/Voucher Templates/Bhairavgarh_Palace_29.html?v=" + random;
            else if (propertyId === 30) filePath = "/Voucher Templates/The_Chinar_Resort_30.html?v=" + random;
            else if (propertyId === 31) filePath = "/Voucher Templates/Ramada_Indor_31.html?v=" + random;
            else if (propertyId === 32) filePath = "/Voucher Templates/Hawthorn_Suites_Dhwarka_32.html?v=" + random;
            else if (propertyId === 28) filePath = "/Voucher Templates/Jasraj_Palace_Tavatmal_28.html?v=" + random;
            else {
                alert("Voucher template not found for this property");
                return;
            }

            // 4. Fetch the HTML template
            const response = await fetch(filePath);
            if (!response.ok) {
                alert("Failed to load voucher template");
                return;
            }
            let templateHTML = await response.text();

            // 5. bankFormData from state (may be null)
            const bank = bankFormData || {};

            // 6. Replace placeholders with actual data (use safe() to avoid "undefined")
            templateHTML = templateHTML
                .replace(/{{Title}}/g, safe(guest.Title))
                .replace(/{{FirstName}}/g, safe(guest.FirstName))
                .replace(/{{LastName}}/g, safe(guest.LastName))
                .replace(/{{BookingDate}}/g, safe(guest.BookingDate))
                .replace(/{{RoomName}}/g, safe(room.RoomName))
                .replace(/{{MealPlan}}/g, safe(room.MeelPlan))
                .replace(/{{CheckInDate}}/g, safe(room.CheckInDate))
                .replace(/{{CheckOutDate}}/g, safe(room.CheckOutDate))
                .replace(/{{Nights}}/g, safe(room.Nights))
                .replace(/{{Guests}}/g, String(guestsToShow))
                .replace(/{{TotalRoom}}/g, String(totalRoom))
                .replace(/{{Travellers}}/g, safe(room.Travellers))
                .replace(/{{RoomRate}}/g, safe(room.RoomRate || "0"))
                .replace(/{{ExtraBedAmount}}/g, safe(room.ExtraBedAmount || "0"))
                .replace(/{{TotalAfterTax}}/g, safe(BookingID.TotalAfterTax || "0"))
                .replace(/{{BONRESID}}/g, safe(BookingID.BONRESID))
                .replace(/{{PMSRESID}}/g, safe(BookingID.PMSRESID))
                .replace(/{{PropertyLogo}}/g, safe(hotel.PropertyLogo))
                .replace(/{{DisplayName}}/g, safe(hotel.DisplayName))
                .replace(/{{Address}}/g, safe(hotel.Address))
                .replace(/{{HotelPhone}}/g, safe(hotel.HotelPhone))
                .replace(/{{HotelMobile}}/g, safe(hotel.HotelMobile))
                .replace(/{{HotelEmail}}/g, safe(hotel.HotelEmail))
                .replace(/{{WebsiteList}}/g, safe(hotel.WebsiteList))
                .replace(/{{BookingComment}}/g, safe(bookingComment))
                .replace(/{{PaymentComment}}/g, safe(paymentComment))

                // ----- BANK FIELDS (from bankFormData) -----
                .replace(/{{BranchName}}/g, safe(bank.BranchName)) // prefer BranchName, else Bankname
                .replace(/{{AccountHoldername}}/g, safe(bank.AccountHoldername))
                .replace(/{{Accountno}}/g, safe(bank.Accountno))
                .replace(/{{IFSCCode}}/g, safe(bank.IFSCCode))

                // other registration fields
                .replace(/{{Reg_CompName}}/g, safe(guest.Reg_CompName))
                .replace(/{{RegCom_Address}}/g, safe(guest.RegCom_Address))
                .replace(/{{RegTax_Number}}/g, safe(guest.RegTax_Number));

            // 7. Generate PDF
            const opt = {
                margin: 0,
                filename: `BookingVoucher_${booking.BONRESID}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
            };

            html2pdf().set(opt).from(templateHTML).save();
        } catch (error) {
            console.error("Error generating voucher PDF:", error);
            alert("Error generating PDF");
        } finally {
            setLoading(false);
        }
    };

    // booking cancle
    const handleCancelBooking = async (booking) => {
        if (!window.confirm("Are you sure you want to cancel this booking?")) return;

        setLoading(true);
        try {
            const result = await ReservationBookingCancle(booking.BONRESID, booking.PropertyID);

            if (result && result.BONRESID) {
                // UI update → Cancelled status dikha do
                setBookingList((prev) =>
                    prev.map((b) =>
                        b.BONRESID === booking.BONRESID
                            ? { ...b, BookingStatus: "Cancelled" }
                            : b
                    )
                );
                alert(`Booking ${result.BONRESID} cancelled successfully!`);
            } else {
                alert("Failed to cancel booking.");
            }
        } catch (error) {
            console.error("Cancel booking error:", error);
            alert("Something went wrong while cancelling booking.");
        } finally {
            setLoading(false);
        }
    };




    return (

        <>
            <style>{`
            
            tr th{
               font-size: 12px !important;
            }
        `}</style>

            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    <div className='card'>
                                        <div className='card-body'>

                                            <form>
                                                <div className='row '>
                                                    <div className="d-flex gap-3">
                                                        <div>
                                                            <label className='form-label '>Booking Date</label>
                                                            <input className='form-control' type='date' />
                                                        </div>
                                                        <div>
                                                            <label className='form-label '>Guest Name</label>
                                                            <input className='form-control' type='text' placeholder='Enter Name' />
                                                        </div>
                                                        <div>
                                                            <label className='form-label '>Company Name</label>
                                                            <input className='form-control' type='text' placeholder='Enter Company' />
                                                        </div>
                                                        <div>
                                                            <label className='form-label '>Check-In</label>
                                                            <input className='form-control' type='date' />
                                                        </div>
                                                        <div>
                                                            <label className='form-label '>Check-Out</label>
                                                            <input className='form-control' type='date' />
                                                        </div>
                                                        <div style={{ marginTop: "27px" }}>
                                                            <button className='btn btn-primary me-2' type='button'  > Filter </button>
                                                            <button className='btn btn-danger' type='button'> Clear </button>
                                                        </div>
                                                    </div>
                                                </div>


                                            </form>
                                        </div>
                                    </div>

                                    {showSuccess && (
                                        <div className="alert alert-success d-flex align-items-center" role="alert">
                                            <i className="feather-check-circle flex-shrink-0 me-2"></i>
                                            <div>Booking Confirmed Successfully!</div>
                                        </div>
                                    )}

                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Reservation Booking List</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table
                                                    id="basic-datatables"
                                                    className="display table  table-bordered table-striped table-hover "
                                                // style={{ width: '100%', tableLayout: 'auto', whiteSpace: 'nowrap' }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "30px" }}>#</th>
                                                            <th style={{ width: "100px" }}>Bon Ref. Id</th>
                                                            <th style={{ width: "100px" }}>Pms id</th>
                                                            <th style={{ width: "95px" }}>Check-in</th>
                                                            <th style={{ width: "105px" }}>Check-out</th>
                                                            <th>Guest Info</th>
                                                            <th>Payment </th>
                                                            <th style={{ width: "80px" }}>Status</th>
                                                            <th style={{ width: "90px" }}>Book On</th>
                                                            <th>Action </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {bookingList.map((booking, index) => (
                                                            <tr key={booking.ID}>
                                                                <td>{index + 1}</td>
                                                                <td>{booking.BONRESID}</td>
                                                                <td>{booking.PMSRESID}</td>
                                                                <td>{booking.CheckInDate}</td>
                                                                <td>{booking.CheckOutDate}</td>
                                                                <td>
                                                                    <div><strong>Name:</strong> {booking.GuestName}</div>
                                                                    <div><strong>Company:</strong> {booking.CompanyName}</div>
                                                                </td>
                                                                <td>
                                                                    <div> ₹{booking.TotalPayment}</div>
                                                                    <span
                                                                        className={
                                                                            booking.PaymentStatus === "Paid"
                                                                                ? "text-success"
                                                                                : booking.PaymentStatus === "Pending"
                                                                                    ? "text-warning"
                                                                                    : "text-secondary"
                                                                        }
                                                                    >
                                                                        {booking.PaymentStatus || "N/A"}
                                                                    </span>
                                                                    {/* <div>Status: {booking.PaymentStatus}</div> */}
                                                                </td>
                                                                <td>
                                                                    <span
                                                                        className={
                                                                            booking.BookingStatus === "Confirmed"
                                                                                ? "text-success"
                                                                                : booking.BookingStatus === "Pending"
                                                                                    ? "text-warning"
                                                                                    : booking.BookingStatus === "Cancelled"
                                                                                        ? "text-danger"
                                                                                        : "text-secondary"
                                                                        }
                                                                    >
                                                                        {booking.BookingStatus || "N/A"}
                                                                    </span>
                                                                </td>
                                                                <td>{booking.BookingDate}</td>
                                                                <td className="text-center">
                                                                    <div className="dropdown dropdown-action" >
                                                                        <a href="/" className="action-icon"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false">
                                                                            <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            {/* <button className="dropdown-item" >
                                                                                <i className="fas fa-edit me-2"></i> Modify
                                                                            </button> */}
                                                                            <button className="dropdown-item" onClick={() => handleCancelBooking(booking)}>
                                                                                <i className="fas fa-trash-alt me-2"></i> Cancelled
                                                                            </button>
                                                                            <button className="dropdown-item" onClick={() => handleGeneratePDF(booking)} >
                                                                                <i className="fas fa-sticky-note me-2"></i> Booking Voucher
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {bookingList.length === 0 && (
                                                            <tr>
                                                                <td colSpan="10" className="text-center">No bookings found.</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

        </>
    )
}

export default ReservationBookingList;
